import { initInstrumentation } from './instrumentation'
import { hasPage, loadPage } from './core/page'
import { ApiError, onError } from './core/api'

initInstrumentation()

// Paridade com o legado (src/js/api.js): sessão expirada volta ao login.
onError.push((err) => {
  if (err instanceof ApiError && err.status === 401) {
    Session.clear()
    Page.gotoPage('login')
  }
})

// Ponte do strangler fig (Fase 3 do MODERNIZACAO.md): o app legado carrega
// este módulo via /moderno/main.js e o Page.init desvia para as páginas
// migradas (src/pages/*) sempre que existe módulo registrado para a rota
// (Page.temPaginaModerna → hasPage).
declare global {
  interface Window {
    PaginasModernas: {
      hasPage: typeof hasPage
      loadPage: typeof loadPage
    }
  }
}

window.PaginasModernas = { hasPage, loadPage }
